export default "__VITE_ASSET__BJIfAwi3__"